module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "px-4 pt-3 pb-4 border-bottom"
  }, [_c('div', {
    staticClass: "font-size-14 font-weight-600 black--text"
  }, [_vm._v("Live Chat")]), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [_c('v-row', [_c('v-col', [_c('div', {
    staticClass: "d-flex align-center gap-10"
  }, [_c('div', [_c('v-avatar', [_c('v-img', {
    attrs: {
      "src": _vm.detail.user_image ||
        require('@/assets/img/siswa.svg')
    }
  })], 1)], 1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "font-weight-bold black--text font-size-14"
  }, [_vm._v("\n                            " + _vm._s(_vm.detail.student_name) + "\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "font-size-12",
    staticStyle: {
      "margin-top": "-3px"
    }
  }, [_vm._v("\n                            Kelas " + _vm._s(_vm.detail.grade) + "\n                        ")])])])]), _vm._v(" "), _c('v-col', [_c('div', {
    staticClass: "d-flex align-center gap-10"
  }, [_c('div', [_c('v-img', {
    attrs: {
      "src": require('@/assets/apps/star.svg'),
      "height": "35",
      "width": "35"
    }
  })], 1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "font-size-12 grey--text"
  }, [_vm._v("Rating")]), _vm._v(" "), _c('div', {
    staticClass: "font-weight-bold font-size-14",
    staticStyle: {
      "margin-top": "-3px",
      "color": "#f2af17"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.detail.rating) + "\n                        ")])])])]), _vm._v(" "), _c('v-col', [_c('div', {
    staticClass: "d-flex align-center gap-10"
  }, [_c('div', [_c('v-img', {
    attrs: {
      "src": require('@/assets/apps/chat.svg'),
      "height": "35",
      "width": "35"
    }
  })], 1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "font-size-12 grey--text"
  }, [_vm._v("\n                            Jumlah Sesi\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "font-weight-bold font-size-14",
    staticStyle: {
      "margin-top": "-3px",
      "color": "#0e97d6"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.detail.total_session) + "\n                        ")])])])]), _vm._v(" "), _c('v-col', [_c('div', {
    staticClass: "d-flex align-center gap-10"
  }, [_c('div', [_c('v-img', {
    attrs: {
      "src": require('@/assets/apps/duration.svg'),
      "height": "35",
      "width": "35"
    }
  })], 1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "font-size-12 grey--text"
  }, [_vm._v("\n                            Durasi Konsul\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "font-weight-bold font-size-14",
    staticStyle: {
      "margin-top": "-3px",
      "color": "#3f45ce"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.detail.consul_duration) + " menit\n                        ")])])])]), _vm._v(" "), _c('v-col', [_c('div', {
    staticClass: "d-flex align-center gap-10"
  }, [_c('div', [_c('v-img', {
    attrs: {
      "src": require('@/assets/apps/timeout.svg'),
      "height": "35",
      "width": "35"
    }
  })], 1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "font-size-12 grey--text"
  }, [_vm._v("\n                            Total Active Time\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "font-weight-bold font-size-14",
    staticStyle: {
      "margin-top": "-3px",
      "color": "#f2af17"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.detail.total_active_time) + " menit\n                        ")])])])])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f380d766","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/Konsul/components/ConsulChatDetail.vue
// module id = 1651
// module chunks = 1